import { getQueryParam } from '../queryParam/getQueryParam';
import { RcPlanParams } from '../queryParam/queryParams.types';
import { saveDeepLinkIntent } from './saveDeepLinkIntent';

const RC_PLAN_STORAGE_KEY = 'rcPlan';

type DeepLinkDefaults = { architecture: string; planSize: string };

const RC_PLAN_INTENT_DEFAULTS: Partial<Record<RcPlanParams, DeepLinkDefaults>> = {
  flex1: { architecture: 'flex', planSize: '1GB' }
};

const setRcPlan = (rcPlan: RcPlanParams) => {
  window.localStorage.setItem(RC_PLAN_STORAGE_KEY, rcPlan);
};

export const getRcPlan = (): RcPlanParams =>
  (window.localStorage.getItem(RC_PLAN_STORAGE_KEY) as RcPlanParams) ?? '';

export const clearRcPlan = () => {
  window.localStorage.removeItem(RC_PLAN_STORAGE_KEY);
};

export const captureLoginIntent = () => {
  const rcPlan = getQueryParam('r');

  if (rcPlan) {
    setRcPlan(rcPlan);
  } else {
    clearRcPlan();
  }

  const defaults = RC_PLAN_INTENT_DEFAULTS[rcPlan];
  saveDeepLinkIntent(
    getQueryParam('architecture') || defaults?.architecture || null,
    getQueryParam('planSize') || defaults?.planSize || null
  );
};
